var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import Popover from '@project/components/Popover';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { IconContainer, popoverStyle } from './styles';
import { IconGallery } from './iconGallery';
import FontIconSingle from '../FontIcons/FontIcon';
var IconPopover = function (_a) {
    var icon = _a.icon, onChange = _a.onChange, color = _a.color, customIcons = _a.customIcons;
    var _b = useState(false), displayPopover = _b[0], setDisplayPopover = _b[1];
    var _c = useState(icon), selectedIcon = _c[0], setSelectedIcon = _c[1];
    useEffect(function () {
        setSelectedIcon(icon);
    }, [icon]);
    var selectIcon = function (iconValue) {
        if (onChange) {
            onChange(iconValue);
        }
        setSelectedIcon(iconValue);
    };
    return (_jsx(Popover, __assign({ bodyStyle: popoverStyle, body: _jsx(IconGallery, { icon: selectedIcon, onSelect: selectIcon, customIcons: customIcons }), isOpen: displayPopover, preferPlace: "below", bgColor: "#eee", borderColor: "#ccc", onOuterAction: function () { return setDisplayPopover(false); } }, { children: _jsx(IconContainer, __assign({ border: true, onClick: function () { return setDisplayPopover(!displayPopover); } }, { children: _jsx(FontIconSingle, { color: color, size: "lg", icon: selectedIcon || faChevronRight }) })) })));
};
export default IconPopover;
